import type { Booking } from '@/services/bookings';
import type { ItineraryItem } from '@/services/itinerary';

function normKind(v: unknown): string {
  return `${v ?? ''}`.trim().toLowerCase();
}

/**
 * Matches transport saved on bookings / itinerary categories / mirrored booking snapshots.
 */
const TRANSPORT_KINDS = new Set([
  'flight',
  'transportation',
  'car',
  'train',
  'ferry',
]);

const LODGING_KINDS = new Set([
  'hotel',
  'lodging',
  'accommodation',
  'resort',
  'hostel',
]);

/** True when the trip already has outbound transport we should remind about ("add flight or ride"). */
export function tripHasSavedTransport(bookings: Booking[], items: ItineraryItem[]): boolean {
  if (bookings.some((b) => TRANSPORT_KINDS.has(normKind(b.type)))) {
    return true;
  }
  return items.some((it) => {
    if (TRANSPORT_KINDS.has(normKind(it.category))) return true;
    return TRANSPORT_KINDS.has(normKind(it.bookingSnapshot?.type));
  });
}

/** True when lodging is already represented for readiness ("add where you are staying"). */
export function tripHasSavedLodging(bookings: Booking[], items: ItineraryItem[]): boolean {
  if (bookings.some((b) => LODGING_KINDS.has(normKind(b.type)))) {
    return true;
  }
  return items.some((it) => {
    const cat = normKind(it.category);
    if (cat === 'hotel' || LODGING_KINDS.has(cat)) return true;
    return LODGING_KINDS.has(normKind(it.bookingSnapshot?.type));
  });
}
